import React, { memo, ComponentProps } from 'react'
import { Alert } from '@mui/material'

interface IInfoMessageProps extends Omit<ComponentProps<typeof Alert>, 'severity'>{
  severity?: ComponentProps<typeof Alert>['severity']
}

const InfoMessage = (props: IInfoMessageProps) => {
  let { children, severity, ...restProps } = props

  return (
    <Alert severity={severity || 'info'} data-cy="info-message" {...restProps}>
      {children}
    </Alert>
  )
}

export default memo(InfoMessage)
